import _ from 'lodash';

export const computePricing = (msrp, incentives) => {
  const totalMsrp = msrp.employeePrice ? msrp.employeePrice : msrp.totalMsrp;
  const eventDiscount = msrp.isConfidencePrice
    ? totalMsrp - msrp.supplierPrice
    : 0;
  const incentiveDiscount =
    (incentives.total ? incentives.total : incentives.value) || 0;
  const totalDiscountWithoutPacakge = incentiveDiscount + eventDiscount;

  const employeePriceDifference = msrp.employeePrice
    ? msrp.totalMsrp - msrp.employeePrice
    : 0;
  const totalDiscount = totalDiscountWithoutPacakge + msrp.opdTotal;
  const totalEmployeeDiscount = employeePriceDifference
    ? totalDiscount + employeePriceDifference
    : 0;
  const netEmployeePrice = totalMsrp - totalDiscountWithoutPacakge;

  return _.assign({}, msrp, {
    incentives: incentives,
    eventDiscount: eventDiscount,
    totalDiscount: totalDiscount,
    netEmployeePrice: netEmployeePrice,
    employeePriceDifference: employeePriceDifference,
    totalEmployeeDiscount: totalEmployeeDiscount,
  });
};
